<template>
    <div class="container-fluid">
        <Navbar></navbar>
        <img src="../assets/logo.png" class="resize">
        <h1>{{ $t('register') }}</h1>
        <!-- TODO: move lang-select to navbar -->
        <button @click="lang('de')">German</button>
        <button @click="lang('en')">English</button>

        <form v-on:submit.prevent="register">
            <div>
                <label for="firstname">{{ $t('form.firstname') }}</label>
                <input type="text" v-model="firstname" id="firstname" v-translate:placeholder="'form.placeholder.firstname'">
            </div>

            <div>
                <label for="lastname">{{ $t('form.lastname') }}</label>
                <input type="text" v-model="lastname" id="lastname" v-translate:placeholder="'form.placeholder.lastname'">
            </div>

            <div>
                <label for="password">{{ $t('form.password') }}</label>
                <input type="password" v-model="password" id="password" v-translate:placeholder="'form.placeholder.password'">
            </div>

            <div>
                <label for="password-rep">{{ $t('form.passwordrep') }}</label>
                <input type="password" v-model="passwordrep" id="password-rep" v-translate:placeholder="'form.placeholder.passwordrep'">
            </div>

            <div>
                <label for="email">{{ $t('form.email') }}</label>
                <input type="text" v-model="email" id="email" v-translate:placeholder="'form.placeholder.email'">
            </div>

            <button type="submit">{{ $t('register') }}</button>
        </form>
    </div>
</template>

<script>
    import Navbar from './global/TopFixedNavbar'
    import HTTP from '../http'

    export default {
        name:       'Register',
        data() {
            return {
                firstname:   "",
                lastname:    "",
                password:    "",
                passwordrep: "",
                email:       ""
            }
        },
        methods:    {
            register: function (e) {
                console.log("submit")
                if (this.password != this.passwordrep) {
                    console.log("nope")
                    return
                }
                HTTP.post('/user/register', {
                    firstname: this.firstname,
                    lastname:  this.lastname,
                    password:  this.password,
                    email:     this.email,
                }).then((response) => {
                    console.log(response)
                }, (err) => {
                    console.log(err)
                })
            },
            lang(lang) {
                this.$store.dispatch("translations/UPDATE_TRANSLATIONS", lang)
            }
        },
        components: {
            Navbar
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

    .resize{
        width: 150px;
        height: auto;
    }

    h1{
        font-size: 1.5em;
    }

    .container-fluid {
        margin           : 0 auto;
        text-align       : center;
        padding          : 1.5rem;
        box-sizing       : border-box;
        background-color : rgba(0, 0, 0, 0.8);
        color            : #ffffff;
    }

    .container-fluid > * {
        display    : block;
        margin     : 0 auto;
        text-align : center;
    }

    form > * {
        margin-bottom : 1em;
    }

    button {
        border           : none;
        background-color : rgba(58, 204, 53, .5);
        color            : white;
        transition       : background-color .2s, color .2s;
        border-radius    : 0.1em;
    }

    button:hover {
        background-color : #3acc35;
        color            : white;
    }

    INPUT {
        border        : 1px solid rgba(166, 166, 166, 1);
        display       : block;
        width         : 100%;
        font-size     : 1rem;
        border-radius : .25rem;
        box-sizing    : border-box;
        padding-right : 5px;
        padding-left  : 5px;
        color         : rgba(166, 166, 166, 1)
    }

    input[type=text],
    input[type=password],
    input[type=date],
    input[type=datetime],
    input[type=number],
    input[type=search],
    input[type=time],
    input[type=url],
    input[type=email],
    textarea,
    select {
        outline          : none;
        max-width        : 10em;
        padding          : 0 5px 0 5px;
        line-hight       : 1.5em;
        background-color : rgba(0, 0, 0, 0.25);
        transition       : border-color .2s, box-shadow .2s;
        margin           : 0 auto;
    }

    input[type=text]:hover,
    input[type=password]:hover,
    input[type=date]:hover,
    input[type=datetime]:hover,
    input[type=number]:hover,
    input[type=search]:hover,
    input[type=time]:hover,
    input[type=url]:hover,
    input[type=email]:hover,
    textarea:hover,
    select:hover {
        border : 1px solid white;
    }

    input[type=text]:focus,
    input[type=password]:focus,
    input[type=date]:focus,
    input[type=datetime]:focus,
    input[type=number]:focus,
    input[type=search]:focus,
    input[type=time]:focus,
    input[type=url]:focus,
    input[type=email]:focus,
    textarea:focus,
    select:focus {
        -moz-box-shadow    : 0 0 4px #3acc35;
        -webkit-box-shadow : 0 0 4px #3acc35;
        box-shadow         : 0 0 4px #3acc35;
        border             : 1px solid #3acc35;
    }

</style>



// WEBPACK FOOTER //
// src/components/Register.vue